import { render, staticRenderFns } from "./ModalNewAditive.vue?vue&type=template&id=cf21a4ac&scoped=true&"
import script from "./ModalNewAditive.vue?vue&type=script&lang=ts&"
export * from "./ModalNewAditive.vue?vue&type=script&lang=ts&"
import style0 from "./ModalNewAditive.vue?vue&type=style&index=0&id=cf21a4ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf21a4ac",
  null
  
)

export default component.exports